import TransitionWrapper from "../../../components/common/transition-wrapper";
import type { ProductQuery } from "../../../__generated__/graphql";

type Product = ProductQuery["product"];

interface ProductCartCtaProps {
  product: Product | null | undefined;
  loading: boolean;
  quantity: number;
  onClick: () => void;
}

const ProductCartCta = ({
  product,
  loading,
  quantity,
  onClick,
}: ProductCartCtaProps) => {
  const discountAmount =
    (product?.price ?? 0) - (product?.userPrice ?? 0);
  const totalPrice = quantity * (product?.userPrice ?? 0);

  return (
    <div
      onClick={onClick}
      className="px-5 py-4 w-full sticky bottom-0 bg-white"
    >
      <div className="absolute left-0 top-[-2.7rem] w-full h-[43px] bg-[#282828] rounded-tl-[10px] rounded-tr-[10px] text-white text-sm font-semibold flex justify-center items-center">
        {loading ? (
          <span>...</span>
        ) : (
          <div>
            {discountAmount.toLocaleString()}
            원 할인받았어요!
          </div>
        )}
      </div>
      <TransitionWrapper
        scale={0.95}
        opacity={0.8}
        className=" w-full h-[60px] flex items-center justify-center bg-[#1562fc] rounded-lg border"
      >
        <div className="text-center flex items-center space-x-1">
          <span className="text-white text-base font-semibold leading-snug">
            {quantity}개
          </span>
          <span className="text-white text-base font-bold leading-snug">
            {loading ? (
              <span>...</span>
            ) : (
              <div className="text-white text-base font-bold leading-snug">
                {totalPrice.toLocaleString()}
              </div>
            )}
          </span>
          <span className="text-white text-base font-semibold leading-snug">
            원 담기
          </span>
        </div>
      </TransitionWrapper>
    </div>
  );
};

export default ProductCartCta;
